import { useMemo } from 'react';
import { useTranslation } from '@frontend/i18n';
import type { NotificationActions } from '@frontend/types';
import {
  BaseNotificationComponentProps,
  BaseNotificationInner,
  BaseNotificationOuter,
} from '../notification-components/base';
import { PreferenceNotification } from '../notification-queue';

export const AutoPausePreferenceNotificationComponent = ({
  notification,
  emit,
  ...rest
}: BaseNotificationComponentProps<PreferenceNotification>) => {
  const { t } = useTranslation();

  const actions: NotificationActions = useMemo(
    () => [
      {
        label: t('Yes'),
        action: () =>
          emit(
            {
              action: 'preference',
              payload: {
                actionType: 'pause',
              },
            },
            notification
          ),
      },
      {
        label: t('No'),
        variant: 'secondary',
        action: () =>
          emit(
            {
              action: 'preference',
              payload: {
                actionType: 'unPause',
              },
            },
            notification
          ),
      },
    ],
    [emit, notification, t]
  );

  return (
    <BaseNotificationOuter actions={actions} notification={notification} emit={emit} isHistorical={false} {...rest}>
      <BaseNotificationInner
        actions={actions}
        title={notification.payload.title || t('Notification Preference')}
        body={notification.payload.body || t('Would you like to adjust your notification settings?')}
        location={notification.location}
        timestamp={notification.timestamp}
        id={notification.id}
        notificationType={notification.payload.notificationType}
        {...rest}
      />
    </BaseNotificationOuter>
  );
};
